import { combineReducers } from 'redux'
import {
	contractsRegistrySlice,
	massUpdateCuratorSlice,
	blackListPartnerSlice,
	matrixRoleSlice,
	massUseMerchantSlice,
	partnerSlice,
	astSlice,
} from 'Pages/pp'

export const pp = combineReducers({
	[massUpdateCuratorSlice.name]: massUpdateCuratorSlice.reducer,
	[contractsRegistrySlice.name]: contractsRegistrySlice.reducer,
	[blackListPartnerSlice.name]: blackListPartnerSlice.reducer,
	[massUseMerchantSlice.name]: massUseMerchantSlice.reducer,
	[matrixRoleSlice.name]: matrixRoleSlice.reducer,
	[partnerSlice.name]: partnerSlice.reducer,
	[astSlice.name]: astSlice.reducer,
})
